import { useDispatch } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { AnalyticsEventOrigins, resolveECommerceEventListName } from '../../../common/utils/analyticsUtils';
import { PublicPage } from '../../../components/PublicPage/PublicPage.js';
import {
  applyAnalyticsEvent,
  eCommerceClickEvent,
  eCommerceDetailEvent,
  eCommerceImpressionEvent,
} from '../../../selfservice/actions/index.js';
import type { Offer, OnlineModel, PageResponse } from '../../../generated/api/models.js';

export const PublicPageContent = (pageResponse: React.PropsWithChildren<PageResponse>) => {
  const {
    children,
    contentBlocks = [],
    onlineModels = [],
    onlineModelHeaders = [],
    siteStructureNodes = [],
    breadcrumbs = [],
  } = pageResponse;
  const dispatch = useDispatch();
  const eventOrigin = AnalyticsEventOrigins.PUBLIC;

  return (
    <PublicPage
      breadcrumbs={breadcrumbs}
      contentBlocks={contentBlocks}
      siteStructureNodes={siteStructureNodes}
      onlineModelHeaders={onlineModelHeaders}
      onlineModels={onlineModels}
      onAnalyticsEvent={eventData => dispatch(applyAnalyticsEvent(eventData))}
      eCommerceEvents={{
        onClickListProduct: (type, position, omhs) =>
          dispatch(eCommerceClickEvent(position, omhs, resolveECommerceEventListName(type, eventOrigin))),
        onSeeListProduct: (type, position, omhs) =>
          dispatch(eCommerceImpressionEvent(position, omhs, resolveECommerceEventListName(type, eventOrigin))),
        onSeeProduct: (oms: OnlineModel[], offers: Offer[][]) => dispatch(eCommerceDetailEvent(oms, offers)),
      }}
      pageId={pageResponse.pageId}
    >
      {children}
    </PublicPage>
  );
};

export const PublicPath = () => {
  const page = useRouteLoaderData('public-path-root') as PageResponse;
  return <PublicPageContent {...page} />;
};
